<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row justify="end" align="center" class="mb-4">
          <v-col cols="12" md="4">
            <v-text-field
              class="ui-form-field"
              v-model="buscarTexto"
              color="secondary"
              background-color="transparent"
              rounded
              filled
              placeholder="Buscar"
              append-icon="mdi-magnify"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card class="ui-module-card" color="primary">
          <v-card-text class="pa-0">
            <v-data-table
              class="primary"
              :headers="headers"
              :items="asignaciones"
              :search="buscarTexto"
              :items-per-page="15"
              :footer-props="{
                'items-per-page-options': [10, 15, 25, 50, 100],
              }"
              :loading="loading"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    idArma: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        { text: 'Nombre Completo', value: 'nombreCompleto', width: '250px', align: 'left' },
        { text: 'CUIP', value: 'CUIP', width: '200px', align: 'left' },
        { text: 'Puesto', value: 'puesto', width: '250px', align: 'left' },
        { text: 'Dependencia', value: 'dependencia', width: '200px', align: 'left' },
      ],
      buscarTexto: '',
      loading: false,
    }
  },

  computed: {
    ...mapGetters('armeria', {
      historialArma: 'getHistorial',
    }),

    asignaciones() {
      if (!this.historialArma || this.historialArma.length === 0) return []

      // Extraer todas las asignaciones del historial
      const asignacionesList = []
      this.historialArma.forEach((arma) => {
        if (arma.Asignaciones && arma.Asignaciones.length > 0) {
          arma.Asignaciones.forEach((asignacion) => {
            asignacionesList.push(asignacion)
          })
        }
      })

      return asignacionesList
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: rgba(108, 92, 231, 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
  color: #e0e0e0 !important;
}
</style>
